import { ActionType, DeleteSlotResponse } from "models/vaccine/schedules";

export const deleteSlotAction = (payload: any) => {
  return {
    type: ActionType.DELETE_SLOT,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DELETE_SLOT_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: DeleteSlotResponse) => {
  return {
    type: ActionType.DELETE_SLOT_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.DELETE_SLOT_RESET,
  };
};
